module.exports = __webpack_public_path__ + "img/illusThrones2.cb4166e5.jpg";